import { EnumOrganizationMemberPermissions } from '@/helpers/enums/permissions.enum';

export const profile = {
  root: {
    name: 'Profile',
    path: '/profile',
    title: 'header.profile',
    icon: 'mdi-account-circle-outline',
    meta: {
      requiresAuth: true,
      name: `${import.meta.env.VITE_DEFAULT_TITLE} | Profile`,
    },
  },
  profileDetails: {
    name: 'Profile Details',
    path: '/profile/details',
    meta: {
      requiresAuth: true,
      name: `${import.meta.env.VITE_DEFAULT_TITLE} | Profile`,
    },
  },

  profileSecurity: {
    name: 'Profile Security',
    path: '/profile/security',
    meta: {
      requiresAuth: true,
      name: `${import.meta.env.VITE_DEFAULT_TITLE} | Profile`,
    },
  },
  settings: {
    name: 'Account Settings',
    path: '/account-settings',
    title: 'header.accountSettings',
    icon: 'mdi-cog-outline',
    meta: {
      requiresAuth: true,
      name: `${import.meta.env.VITE_DEFAULT_TITLE} | Account Settings`,
    },
  },
  helpCenter: {
    name: 'Help Center',
    path: '/help-center',
    title: 'header.helpCenter',
    icon: 'mdi-lifebuoy',
    meta: {
      requiresAuth: true,
      name: `${import.meta.env.VITE_DEFAULT_TITLE} | Help Center`,
    },
  },
  favorite: {
    root: {
      name: 'Favorite',
      path: '/favorite',
      title: 'header.favorite',
      meta: {
        requiresAuth: true,
        name: `${import.meta.env.VITE_DEFAULT_TITLE} | Favorite`,
      },
    },
    events: {
      name: 'Favorite Events',
      path: '/favorite/events',
    },
    courses: {
      name: 'Favorite Courses',
      path: '/favorite/courses',
    },
  },
  activityLog: {
    root: {
      name: 'Activity Log',
      title: 'menu.activityLog',
      path: '/activity-log',
      icon: 'mdi-history',
      meta: {
        requiresAuth: true,
        name: `${import.meta.env.VITE_DEFAULT_TITLE} | Activity Log`,
        needLanguage: true,
      },
    },
  },
  myCertificates: {
    root: {
      name: 'My Certificates',
      path: '/my-certificates',
      title: 'header.myCertificates',
      meta: {
        requiresAuth: true,
        name: `${import.meta.env.VITE_DEFAULT_TITLE} | My Certificates`,
        shouldHaveCertificatesEnabled: true,
      },
    },
  },
  savedPost: {
    root: {
      name: 'Saved Post',
      path: '/saved-post',
      title: 'header.savedPost',
      meta: {
        requiresAuth: true,
        name: `${import.meta.env.VITE_DEFAULT_TITLE} | Saved Post`,
        memberPermissions: [
          EnumOrganizationMemberPermissions.AccessCommunities,
        ],
        shouldHaveGroup: true,
      },
    },
  },
  zoomPolicy: {
    name: 'Zoom Policy',
    path: '/zoom-policy',
    meta: {
      requiresAuth: false,
      name: `${import.meta.env.VITE_DEFAULT_TITLE} | Zoom Policy`,
    },
  },
};
